import { render } from "./Compramodal.vue?vue&type=template&id=550fc9f4&scoped=true"
import script from "./Compramodal.vue?vue&type=script&lang=js"
export * from "./Compramodal.vue?vue&type=script&lang=js"

import "./Compramodal.vue?vue&type=style&index=0&id=550fc9f4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550fc9f4"]])

export default __exports__